import React from 'react';
import {useSelector} from 'react-redux';
import Questionnaire1Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire7Screen';
import Questionnaire10Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire10Screen';
import Questionnaire8Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/vaginal-dryness-treatment/Questionnaire9Screen';
import {RootState} from '~/redux/root-reducer';
import {VAGINAL_DRYNESS_TREATMENT_KEYS} from '~/constants/medical-questionnaires';
import {trackPageViewGA} from '~/services/google-analytics';

const VaginalDrynessTreatment = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case VAGINAL_DRYNESS_TREATMENT_KEYS.START:
        trackPageViewGA('/vaginal-dryness-treatment/start', 'MDQ-Vaginal Dryness Treatment - Start');
        return <Questionnaire1Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.PROFILE:
        trackPageViewGA('/vaginal-dryness-treatment/profile', 'MDQ-Vaginal Dryness Treatment - Profile');
        return <Questionnaire2Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.INVALID:
        trackPageViewGA('/vaginal-dryness-treatment/invalid', 'MDQ-Vaginal Dryness Treatment - Invalid');
        return <Questionnaire3Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.SELECT_SYMPTOMS:
        trackPageViewGA(
          '/vaginal-dryness-treatment/select-symptoms',
          'MDQ-Vaginal Dryness Treatment - Select Symptoms',
        );
        return <Questionnaire4Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.DESCRIBE_CURRENT_SYMPTOMS:
        trackPageViewGA(
          '/vaginal-dryness-treatment/describe-current-symptoms',
          'MDQ-Vaginal Dryness Treatment - Describe Current Symptoms',
        );
        return <Questionnaire5Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.HAVING_REGULAR_PERIODS:
        trackPageViewGA(
          '/vaginal-dryness-treatment/having-regular-periods',
          'MDQ-Vaginal Dryness Treatment - Having Regular Periods',
        );
        return <Questionnaire6Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING:
        trackPageViewGA(
          '/vaginal-dryness-treatment/current-or-history-of-any-of-following',
          'MDQ-Vaginal Dryness Treatment - Current Or History Of Any Of Following',
        );
        return <Questionnaire7Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS:
        trackPageViewGA(
          '/vaginal-dryness-treatment/up-to-date-pap-smears-cervical-screenings',
          'MDQ-Vaginal Dryness Treatment - Up To Date Pap Smears Cervical Screenings',
        );
        return <Questionnaire8Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.UP_TO_DATE_BREAST_SCREENINGS:
        trackPageViewGA(
          '/vaginal-dryness-treatment/up-to-date-breast-screenings',
          'MDQ-Vaginal Dryness Treatment - Up To Date Breast Screenings',
        );
        return <Questionnaire9Screen />;
      case VAGINAL_DRYNESS_TREATMENT_KEYS.OTHER_CONDITION_OR_MEDICAL_HISTORY:
        trackPageViewGA(
          '/vaginal-dryness-treatment/other-condition-or-medical-history',
          'MDQ-Vaginal Dryness Treatment - Other Condition Or Medical History',
        );
        return <Questionnaire10Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default VaginalDrynessTreatment;
